// extracted by mini-css-extract-plugin
module.exports = {"root":"NavSection_root__3pIvK","item":"NavSection_item__A0oUm","link":"NavSection_link__2z0mE"};